// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2TTav","inner":"Footer_inner__2xlw1"};